




























import store from '../store'
import { toItem } from '../helper'
import { Component, Vue, Watch } from 'vue-property-decorator'
@Component

export default class GetEveryMore extends Vue {
  pic_url: any = ''
  items: any = []
  listItems: any = []
  order: boolean = true
  show: boolean = false
  async mounted() {
    await this.init()
    // 设置分享时显示的图片和标题
    await store.setupShare({imgUrl: this.pic_url + '?x-oss-process=image/resize,w_750', title: '常爸小学堂'})
  }
  get playcount() {
    let f = !!(this.playcount > 9999)
    return f ? `${(this.playcount / 10000).toFixed(1)}万` : this.playcount
  }
  toClickItem(options) {
    return toItem(options)
  }
  change() {
    this.order = !this.order
  }
  async init() {
    let { data } = await this.$axios.get(`/api/mobile/audios/resource2/getDailySentenceList`, {
      params: {
        offset: this.items.length,
        limit: 20,
        order: 'DESC'
      }
    })
    this.pic_url = data.pic_url
    this.items = [...this.items, ...data.list]

    this.listItems = []
    for (let item of this.items) {
      let last = this.listItems.slice(-1)[0]
      let idate = Date.newDate(item.open_time).format('YYYY-MM-DD')
      if (idate === new Date().format('YYYY-MM-DD')) {
        idate = '今天'
      }
      if (!last || last.date !== idate) {
        this.listItems.push({date: idate, audios: []})
      }
      let audios = this.listItems.slice(-1)[0].audios
      item.audio_track !== '每日一句 ' && audios.push(item)
    }
    this.show = true
  }
}
